import { GameVer, lstring, useRealm, useT } from "~/util/Lang";
import { Icon } from "../ui/Icon";
import css from "./SkillInfoBox.module.css";

type SkillProps = {
  icon: string;
  name: lstring;
  desc: lstring;
  operateType: "P" | "A1" | "A2" | "A3" | "T" | "DA1" | "DA2" | "CA1" | "CA5";
};

export function SkillInfoBox(props: { skill: SkillProps; gver?: GameVer }) {
  const skill = props.skill;
  const realm = useRealm();
  const t = useT();
  return (
    <div className={css.root}>
      <div className={css.skillHeading}>
        {skill.icon && <Icon icon={skill.icon} alt={t(skill.name)} />}
        <div>
          <div className={css.skillName}>{t(skill.name)}</div>
        </div>
      </div>

      {skill.desc[realm.lang] !== "none" && (
        <div className={css.skillDesc}>
          {t(skill.desc).replace(/\\\\n /g, "\n")}
        </div>
      )}

      <SkillType operateType={skill.operateType} />
    </div>
  );
}

function SkillType(params: {
  operateType: "P" | "A1" | "A2" | "A3" | "T" | "DA1" | "DA2" | "CA1" | "CA5";
}) {
  let type: string | null = null;
  switch (params.operateType) {
    case "A1":
    case "A2":
    case "A3":
      type = "Active";
      break;
    case "P":
      type = "Passive";
      break;
  }
  return (
    type && (
      <div className={css.skillType}>
        Type: <span>{type}</span>
      </div>
    )
  );
}
